<template>
  <b-sidebar
    id="sidebar"
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    no-close-on-backdrop
    right
    @shown="loadData"
    @hidden="resetForm"
    @change="(val) => $emit('update:is-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0 text-capitalize">
          {{
            (isAdd ? $t("actions.add") : $t("actions.edit")) +
            " " +
            $tc("intelbras.panels", 1)
          }}
        </h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide"/>
      </div>
      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <!-- Name -->
          <validation-provider #default="validationContext" name="name" rules="required">
            <b-form-group
              class="text-capitalize"
              :label="$t('intelbras.name')"
              label-for="firstName"
            >
              <b-form-input
                id="name"
                v-model="itemData.name"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Instance Host -->
         <!--  <validation-provider #default="validationContext" name="Instance Host" rules="required">
            <b-form-group
              class="text-capitalize"
              :label="$t('intelbras.instance_host')"
              label-for="instance_host"
            >
              <b-form-input
                id="instance_host"
                v-model="itemData.instance_host"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <!-- Panel model -->
          <validation-provider
            #default="validationContext"
            name="Panel model"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('intelbras.panel_model')"
              label-for="panel_model"
            >
              <v-select
                v-model="itemData.panel_model"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="panelModelOptions"
                :reduce="(val) => val.value"
                input-id="panel_model"
                @input="getProfiles($event)"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Profile -->
         <!--  <validation-provider
            #default="validationContext"
            name="profile"
            rules="required"
          > -->
            <b-form-group
              class="text-capitalize"
              :label="$t('intelbras.profile')"
              label-for="profile"
            >
              <v-select
                label="name"
                v-model="itemData.intelbras_profile_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="profiles"
                :reduce="(val) => val.id"
                input-id="profile"
              />
             <!--  <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback> -->
            </b-form-group>
         <!--  </validation-provider> -->

          <!-- Client Password -->
          <validation-provider
            #default="validationContext"
            name="Client Password"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('intelbras.client_password')"
              label-for="client_password"
            >
              <b-form-input
                id="client_password"
                v-model="clientPassword"
                :state="getValidationState(validationContext)"
                type="password"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Remote CFG Password -->
          <validation-provider
            #default="validationContext"
            name="Remote CFG Password"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('intelbras.remote_control_password')"
              label-for="remote_cfg_password"
            >
              <b-form-input
                id="remote_cfg_password"
                v-model="remoteCfgPassword"
                :state="getValidationState(validationContext)"
                type="password"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Unit -->
          <validation-provider #default="validationContext" name="Unit">
            <b-form-group
              class="text-capitalize"
              :label="$tc('unit.title', 2)"
              label-for="id_unit"
              :state="getValidationState(validationContext)"
            >
              <select-paginate
                v-model="itemData.id_unit"
                :items="facilitiesOptions"
                input-id="id_unit"
                :multiple="true"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Center -->
          <validation-provider #default="validationContext" name="Center" rules="required">
            <b-form-group
              class="text-capitalize"
              :label="$tc('centers.title', 1)"
              label-for="id_center"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.id_center"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="centerOptions"
                :reduce="(val) => val.value"
                input-id="id_center"
                @input="changeCenter"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Sector -->
          <validation-provider #default="validationContext" name="Sector" rules="required">
            <b-form-group
              label="Sector"
              label-for="id_sector"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.id_sector"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sectorOptions"
                :reduce="(val) => val.value"
                input-id="id_sector"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <!-- Contact ID Number -->
          <!-- <validation-provider
            #default="validationContext"
            name="Contact ID Number"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('intelbras.num_conact_id')"
              label-for="contact_id_number"
            >
              <b-form-input
                id="contact_id_number"
                v-model="itemData.contact_id_number"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2 text-capitalize"
              type="submit"
            >
              {{ isAdd ? $t("actions.add") : $t("actions.edit") }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="text-capitalize"
            >
              {{ $t("actions.cancel") }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
  BInputGroupAppend,
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver, validate} from "vee-validate";
import vSelect from "vue-select";
import {computed, ref} from "@vue/composition-api";
import {required, alphaNum, email, positive, required_if} from "@validations";
import {useToast} from "vue-toastification/composition";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import SelectPaginate from "../../components/SelectPaginate.vue";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BInputGroupAppend,
    BButton,
    vSelect,
    BFormCheckbox,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    SelectPaginate,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isSidebarActive",
    event: "update:is-sidebar-active",
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    itemEdit: {
      type: Object,
      required: false,
    },
    facilitiesOptions: {
      type: Array,
      required: true,
    },
    centerOptions: {
      type: Array,
      required: true,
    },
    sectorOptions: {
      type: Array,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      positive,
    };
  },
  setup(props, {emit}) {
    const blankData = {
      name: null,
      instance_host: null,
      panel_model: null,
      panel_listening_port: null,
      contact_id_number: null,
      client_password: null,
      remote_cfg_password: null,
      id_unit: null,
      id_center: null,
      id_sector: null,
      intelbras_profile_id: null
    };

    const panelModelOptions = [
      {value: "amt_2018_e_smart", label: "AMT 2018 E Smart"},
      {value: "amt_4010_smart", label: "AMT 4010 Smart"},
    ];

    const toast = useToast();
    const clientPassword = ref('');
    const remoteCfgPassword = ref('');
    const profiles = ref([]);

    const itemData = ref(JSON.parse(JSON.stringify(blankData)));
    const resetData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankData));
      clientPassword.value = '';
      remoteCfgPassword.value = '';
    };

    const onSubmit = () => {
      let dispatch;

      itemData.value.id_unit = itemData.value.id_unit.map((unit) => unit.value);

      if (clientPassword.value) itemData.value.client_password = clientPassword.value;
      if (remoteCfgPassword.value) itemData.value.remote_cfg_password = remoteCfgPassword.value;

      if (props.isAdd) {
        dispatch = store.dispatch("intelbras_panels/add", itemData.value);
      } else {
        const req = {
          id: itemData.value.id,
          params: itemData.value,
        };

        dispatch = store.dispatch("intelbras_panels/edit", req);
      }

      dispatch
        .then((response) => {
          if (response.success) {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });

            emit("refetch-data");
            emit("update:is-sidebar-active", false);
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const {refFormObserver, getValidationState, resetForm} = formValidation(resetData);

    const loadData = () => {
      if (!props.isAdd) {
        itemData.value = props.itemEdit;
      }

      getProfiles(itemData.value.panel_model);

      itemData.value.id_unit = props.itemEdit.device.units.map((value) => ({
        value: value.id,
        label: value.description,
        id_tenant: value.router.id_tenant,
      }));
    };

    const changeCenter = () => {
      store
        .dispatch("sector/getAll", {
          id_center: [itemData.value.id_center],
        })
        .then(() => {
          const sector = props.sectorOptions.filter(
            (item) => item.value === itemData.value.id_sector
          );

          if (sector.length === 0) itemData.value.id_sector = "";
        });
    };

    const getProfiles = (panel_model) => {
      store.dispatch("intelbras_profiles/getAll", {
        panel_model
      })
      .then((response) => {
          let { data } = response;

          profiles.value = data;
      });
    }

    return {
      itemData,
      onSubmit,
      clientPassword,
      profiles,
      remoteCfgPassword,
      refFormObserver,
      getValidationState,
      loadData,
      resetForm,

      changeCenter,
      getProfiles,

      panelModelOptions,
    };
  },
};
</script>
